export enum LayoutType {
  Square = "square",
  HorizontalSquare = "horizontalSquare",
  VerticalSquare = "verticalSquare",
}

/** Keep in sync with CSS: @media (max-width: 1023px) */
export const MOBILE_BREAKPOINT = 1024;
